import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import IELTSBandScore, { getCorrectIncorrectCounts } from './IELTSBandScore';
import { getBandScore, parseAnalytics } from './utils/scoreHelpers';
import './SpeakingResults.css';

export default function ReadingResultsFrame({ children, apiResult, totalQuestions, duration, durationLabel = 'Duration', testType = 'Reading', headerAction, teacherReviewContent }) {
  const [reviewOpen, setReviewOpen] = useState(false);
  useEffect(() => { setReviewOpen(false); }, [apiResult, testType]);
  const counts = getCorrectIncorrectCounts(apiResult?.response, parseAnalytics(apiResult?.response?.analytics), totalQuestions);
  const total = counts.correct + counts.incorrect;
  const complete = Boolean(apiResult?.response) && !counts.incomplete && total > 0;
  const band = getBandScore(apiResult);

  return <section className="reading-results" aria-label={`IELTS ${testType} results`}>
    <div className="sr-main">
      <header className="sr-heading">
        <div><span className="sr-eyebrow">IELTS / {testType.toUpperCase()}</span><h2>Your {testType.toLowerCase()} results</h2></div>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap', maxWidth: '100%' }}>
          {teacherReviewContent && <Button variant="outlined" onClick={() => setReviewOpen(true)} sx={{ textTransform: 'none', flexShrink: 0 }}>Teacher Review</Button>}
          {headerAction || (complete && <span className="sr-status">Evaluation complete</span>)}
        </Box>
      </header>
      {counts.incomplete && <IELTSBandScore apiResult={apiResult} showCorrectIncorrect totalQuestions={totalQuestions} />}
      <div className="rr-summary">
      {!counts.incomplete && (
        <>
          <div className="rr-band"><span>Overall band</span><div><strong>{band ?? '-'}</strong><span> / 9</span></div></div>
          <div><span>Correct</span><strong className="sr-recorded">{complete ? counts.correct : '-'}</strong></div>
          <div><span>Incorrect</span><strong className="sr-missing">{complete ? counts.incorrect : '-'}</strong></div>
          <div><span>Accuracy</span><strong>{complete ? `${Math.round(counts.correct / total * 100)}%` : '-'}</strong></div>
        </>
      )}
      {duration && <div className="sr-duration"><span className="sr-duration-icon" aria-hidden="true"><AccessTimeRoundedIcon /></span><div><span>{durationLabel}</span><strong>{duration}</strong></div></div>}
      </div>
      {children}
    </div>
    <Dialog open={reviewOpen && Boolean(teacherReviewContent)} onClose={() => setReviewOpen(false)} fullWidth maxWidth="sm" aria-labelledby="teacher-review-title" PaperProps={{ sx: { borderRadius: '8px' } }}>
      <DialogTitle id="teacher-review-title" sx={{ pr: 7 }}>
        {testType} teacher review
        <IconButton aria-label="Close teacher review" onClick={() => setReviewOpen(false)} sx={{ position: 'absolute', right: 12, top: 12 }}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent>{teacherReviewContent}</DialogContent>
    </Dialog>
  </section>;
}
